/**
* Book Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Book Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';

( function( app ) {
  const COMPONENT = {

    className: 'book-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );
      const section = document.querySelector( '.book-hero' );
      const topBlue = section.querySelector( '.arrows-top .js-blue-arrow' );
      const topGreen = section.querySelector( '.arrows-top .js-icon-green-arrow-outline' );
      const bottomGreen = section.querySelector( '.arrows-bottom .js-green-arrow' );
      const bottomYellow = section.querySelector( '.arrows-bottom .js-yellow-arrow-outline' );

      CustomEase.create( 'fastForwardHero', 'M0,0,C0.266,0.412,0.451,0.545,0.58,0.666,0.612,0.696,0.753,0.829,0.87,0.914,0.928,0.956,0.942,1,1,1 ' );

      gsap
          .timeline( {
            defaults: {
              ease: 'fastForwardHero',
            },
          } )
          .from( topBlue, {x: '-75vw', opacity: 0}, 0.25 )
          .from( bottomGreen, {x: '-75vw', opacity: 0}, 0.45 )
          .from( topGreen, {x: '-75vw', opacity: 0}, 0.5 )
          .from( bottomYellow, {x: '-75vw', opacity: 30}, 0.8 );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'book-hero', COMPONENT );
} )( app );
